import { rSlider } from "./rSlider.js";
import { pushEnhancedEcommerce } from "./enhanced-ecommerce.js";
import Utils from "./utils";

declare var _getProductsUrl: string;
declare var _ShopByProduct_CurrentOrder: string;
declare var _Default_SortOrder: string;
declare var _pageSize: number;
declare var _numberOfItems: number;
declare var _filtersModel: any;
declare var _ShopByProduct_RefreshProductListUrl: string;
declare var _hasFilter: any;
declare var _pageName: string;
declare var _inStock: boolean;
declare var _pageID: number;
declare var _pageRegionID: number;
declare var _categoryID: number;
declare var _pageNum: number;
declare var _maxNumItems: number;
declare var _maxPage: number;

var ee: any;

/******START - range slider functions */
var mySlider: any;
const mediaQuery = window.matchMedia('(max-width: 1023px)');

var _scrollUp = true;
var _refreshProducts = false;
var _resetSlider = false;
var _isPageLoad = false;
var _isFiltering = false;
var pageWidth = window.innerWidth;

var priceValues: any;
var triggerSliderOnChange: boolean = false;
var priceFilterSteps = 80;

var windowWidth = 0;

var maxDisplayPageNum: number = 5;// mediaQuery.matches ? 5 : 10;
var _pageHasChanged: boolean = false;

const urlParams = ['q', 'page', 'sort', 'stockonly', 'min', 'max',
    'b', 'bs', 'cat', 'pt', 'pst', 'layout', 'cc']

function initRangeSlider() {
    let rangeSlider = document.querySelectorAll('.rs-container');
    let filter = (<HTMLInputElement>document.getElementById("priceRangeSlider"));

    if (!rangeSlider || rangeSlider.length == 0) {
        triggerSliderOnChange = false;
        if (window.location.href.indexOf('?') > 0 && (window.location.href.indexOf('min=') > 0 || window.location.href.indexOf('max=') > 0)) {
            let min = "";
            if (window.location.href.indexOf('min=') != -1) {
                min = window.location.href.substring(window.location.href.indexOf('min=') + 4);
                min = min.substring(0, min.indexOf('&') > 0 ? min.indexOf('&') : min.length);
                _filtersModel.PriceRange.SelectedMin = min;
            } else {
                min = Math.floor(_filtersModel.PriceRange.MinProductPrice).toString();
            }

            let max = window.location.href.substring(window.location.href.indexOf('max=') + 4);
            max = max.substring(0, max.indexOf('&') > 0 ? max.indexOf('&') : max.length);
            _filtersModel.PriceRange.SelectedMax = max;

            let filter = (<HTMLInputElement>document.getElementById("priceRangeSlider"));
            if (filter) {
                filter.value = min + ',' + max;

                var detailsToggle = filter!.closest("details")!;
                if (detailsToggle &&
                    (_filtersModel.PriceRange.SelectedMin != _filtersModel.PriceRange.MinProductPrice
                        || _filtersModel.PriceRange.SelectedMax != _filtersModel.PriceRange.MaxProductPrice)) {
                    detailsToggle.setAttribute("open", "");
                }
            }
        }
        //else {

        //    if (filter) {
        //        var split = filter.value.split(",");
        //        _filtersModel.PriceRange.SelectedMin = Math.round(parseInt(split[0]));
        //        _filtersModel.PriceRange.SelectedMax = Math.round(parseInt(split[1]));
        //    }
        //}

        if (filter) {
            if (_resetSlider) {
                _filtersModel.PriceRange.SelectedMin = null;
                _filtersModel.PriceRange.SelectedMax = null;
                _resetSlider = false;
            }
            let setStart = !isNaN(parseInt(_filtersModel.PriceRange.SelectedMin)) ? parseInt(_filtersModel.PriceRange.SelectedMin) : Math.floor(_filtersModel.PriceRange.MinProductPrice);
            let setEnd = !isNaN(parseInt(_filtersModel.PriceRange.SelectedMax)) ? parseInt(_filtersModel.PriceRange.SelectedMax) : Math.ceil(_filtersModel.PriceRange.MaxProductPrice);

            mySlider = new rSlider({
                target: '#priceRangeSlider',
                values: { min: Math.floor(_filtersModel.PriceRange.MinProductPrice), max: Math.ceil(_filtersModel.PriceRange.MaxProductPrice) },
                step: Math.round((_filtersModel.PriceRange.MaxProductPrice - _filtersModel.PriceRange.MinProductPrice) / priceFilterSteps),
                range: true,
                tooltip: true,
                scale: true,
                labels: true,
                prefixToScaleValues: '£',
                set: [setStart, setEnd],
                /*onChange: (values: any) => {
                    //priceValues = values;
                    console.log(mySlider);
                    console.log(values);
                    //debounce(onPriceChange, 1000);
                    if (triggerSliderOnChange) {
                        showHideSpinner(true);
                        var split = values.split(",");

                        if (_filtersModel.PriceRange.SelectedMax != split[1] ||
                            _filtersModel.PriceRange.SelectedMin != split[0]) {

                            _filtersModel.PriceRange.SelectedMin = split[0];
                            _filtersModel.PriceRange.SelectedMax = split[1];
                            applyFilters();
                        }
                        else showHideSpinner(false);
                    }
                    else triggerSliderOnChange = true;
                }*/
                onChange: mediaQuery.matches ? debouncedPriceChangeFunction : onPriceChange
            });
        }
    }
}

function debounce<Params extends any[]>(
    func: (...args: Params) => any,
    timeout: number,
): (...args: Params) => void {
    let timer: NodeJS.Timeout
    return (...args: Params) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            func(...args)
        }, timeout)
    }
}

const debouncedResizeFunction = debounce(checkForMobileResize, 500);
const debouncedPriceChangeFunction = debounce(onPriceChange, 2000);

function onPriceChange(values: any) {
    if (triggerSliderOnChange) {
        //showHideSpinner(true);
        var split = values.split(",");
        if (_filtersModel.PriceRange.SelectedMax != split[1] ||
            _filtersModel.PriceRange.SelectedMin != split[0]) {

            _filtersModel.PriceRange.SelectedMin = split[0];
            _filtersModel.PriceRange.SelectedMax = split[1];
            if (_filtersModel.PriceRange.SelectedMin != null && _filtersModel.PriceRange.SelectedMax != null && _filtersModel.PriceRange.SelectedMin == _filtersModel.PriceRange.SelectedMax) {
                let step = Math.round((_filtersModel.PriceRange.MaxProductPrice - _filtersModel.PriceRange.MinProductPrice) / priceFilterSteps);
                _filtersModel.PriceRange.SelectedMax = (step + parseInt(_filtersModel.PriceRange.SelectedMax));
            }
            applyFilters();
        }
        else showHideSpinner(false);

    }
    else {
        triggerSliderOnChange = true;
        //on first initialisation
        var split = values.split(",");
        if (_filtersModel.PriceRange.SelectedMin != null && _filtersModel.PriceRange.SelectedMax != null && _filtersModel.PriceRange.SelectedMin == _filtersModel.PriceRange.SelectedMax) {
            let step = Math.round((_filtersModel.PriceRange.MaxProductPrice - _filtersModel.PriceRange.MinProductPrice) / priceFilterSteps);
            _filtersModel.PriceRange.SelectedMax = (step + parseInt(_filtersModel.PriceRange.SelectedMax));
        }
    }
}

//function checkForMobileOLD() {
//    if (mediaQuery.matches) {
//        let mobilefiltersection = document.getElementById('modal-mobile-filters');
//        if (!mobilefiltersection) {
//            //create the filters for mobile
//            mobilefiltersection = document.createElement('div');
//            mobilefiltersection.setAttribute('id', 'modal-mobile-filters');
//            mobilefiltersection.setAttribute('class', 'modal slide-in-modal bg-white');
//            mobilefiltersection.setAttribute('data-modal', '');
//            mobilefiltersection.setAttribute("hidden", "hidden");
//            mobilefiltersection.innerHTML = `<div class="inner filter-menu form full-width" data-variant="mobile">
//                                                <h3 class="modal-heading font-serif">Filters</h3>
//                                                <div class="[ inner ] [ margin-200 margin-top-only ]" id="filter-content-area-mobile">
//                                                </div>
//                                                </div>`;
//            let prefooter = document.getElementsByClassName('pre-footer');
//            if (prefooter && prefooter.length > 0) {
//                let prefooterElem = prefooter[0];
//                let parentElem = prefooter[0].parentNode;
//                if (parentElem) {
//                    parentElem.insertBefore(mobilefiltersection, prefooterElem);
//                }
//            }
//        }
//        let contentAreaMobile = document.getElementById('filter-content-area-mobile');
//        let contentAreaDesktop = document.getElementById('filter-content-area-desktop');
//        let rangeSlider = contentAreaDesktop?.querySelectorAll('.rs-container');
//        if (contentAreaMobile && contentAreaDesktop && contentAreaMobile.innerHTML.trim() == '') {
//            if (rangeSlider && rangeSlider.length > 0) {
//                rangeSlider[0].remove();
//            }
//            contentAreaMobile.innerHTML = (contentAreaDesktop.cloneNode(true) as HTMLElement).innerHTML;
//            contentAreaDesktop.innerHTML = '';
//            initRangeSlider();
//        }
//        if ((window as any).ARIAmodal) {
//            (window as any).ARIAmodal.init();
//            addEventListeners();
//        }
//    }
//    else {
//        //close modal if open
//        let modalClose = document.querySelector('#modal-mobile-filters .a11y-modal__close-btn');
//        if (modalClose) {
//            (modalClose as HTMLElement).click();
//        }
//        let mobilefiltersection = document.getElementById('modal-mobile-filters');
//        let contentAreaMobile = document.getElementById('filter-content-area-mobile');
//        let contentAreaDesktop = document.getElementById('filter-content-area-desktop');
//        let rangeSlider = contentAreaMobile?.querySelectorAll('.rs-container');
//        if (contentAreaMobile && contentAreaDesktop && contentAreaDesktop.innerHTML.trim() == '') {
//            if (rangeSlider && rangeSlider.length > 0) {
//                rangeSlider[0].remove();
//            }
//            contentAreaDesktop.innerHTML = (contentAreaMobile.cloneNode(true) as HTMLElement).innerHTML;
//            contentAreaMobile.innerHTML = '';
//            initRangeSlider();
//        }
//        if (mobilefiltersection) mobilefiltersection.remove();
//    }    
//}

debouncedResizeFunction();
initRangeSlider();
/**END - range slider functions*/

var DEFAULT_FILTERS = { "IsInStockShowAll": true };
var ListLayoutCookieName = "GAK_ListLayout";

//function addEventListenersMobile() {
//    var showAllRad = document.getElementById("showAllRad")!;
//    if (showAllRad) showAllRad.addEventListener("change", handleShowAll);

//    var inStockOnlyRad = document.getElementById("inStockOnlyRad")!;
//    if (inStockOnlyRad) inStockOnlyRad.addEventListener("change", handleInStockOnly);
//    //extra check for mobile filters as they keep clearing
//    if (_inStock) {
//        if (showAllRad) (<HTMLInputElement>showAllRad).checked = false;
//        if (inStockOnlyRad) (<HTMLInputElement>inStockOnlyRad).checked = true;
//    }
//    else {
//        if (showAllRad) (<HTMLInputElement>showAllRad).checked = true;
//        if (inStockOnlyRad) (<HTMLInputElement>inStockOnlyRad).checked = false;
//    }

//    var showAllBrandsButton = document.getElementById("showAllFilters-brands")!;
//    if (showAllBrandsButton) showAllBrandsButton.addEventListener("click", (e) => handleFilterToggle(e, showAllBrandsButton, "brands"));

//}

function addEventListeners() {
    if (_hasFilter) {
        addPagingEventListeners();
        addFiltersEventListeners();
    }
    var moreInfoLink = document.getElementById("more-info-link")!;
    var moreInfoSection = document.getElementById("more-panel")!;
    if (moreInfoLink) moreInfoLink.addEventListener("click", (e) => {
        e.preventDefault();
        if (moreInfoSection) moreInfoSection.scrollIntoView({ behavior: "smooth" });
    });

    var browseLink = document.querySelector("a[href='#products-panel']")!;
    var browseSection = document.getElementById("products-panel")!;
    if (browseLink) browseLink.addEventListener("click", (e) => {
        e.preventDefault();
        if (browseSection) browseSection.scrollIntoView({ behavior: "smooth" });
    });

    //view all brands
    if (document.getElementsByClassName('toggle-parent').length) {
        var showMoreToggles = document.querySelectorAll('.toggle-control .btn');
        showMoreToggles.forEach(function (toggle) {
            var newToggle = toggle.cloneNode(true);
            newToggle.addEventListener('click', handleToggleClick);
            toggle.parentNode!.replaceChild(newToggle, toggle);
        })
    }

    //mobile filters
    let modalBtn = document.getElementById('btnOpenMobileFilter');
    if (modalBtn) {
        modalBtn.addEventListener("click", (e) => {
            openCloseFilterModal(true);
        });
    }
    let modalClose = document.querySelector("#productListingFilter .a11y-modal__close-btn");
    if (modalClose) modalClose.addEventListener("click", (e) => {
        e.preventDefault();
        closeModal();
    });
    let applyFilterBtn = document.querySelectorAll(".btn.filter-apply");
    applyFilterBtn.forEach(function (applyBtn) {
        applyBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closeModal();
        });
    });

    let viewControlList = document.getElementById('productlist-view-list');
    if (viewControlList) {
        viewControlList.addEventListener('click', function (e) {
            e.preventDefault();
            viewAsGrid(false);
        });
    }
    let viewControlGrid = document.getElementById('productlist-view-grid');
    if (viewControlGrid) {
        viewControlGrid.addEventListener('click', function (e) {
            e.preventDefault();
            viewAsGrid(true);
        });
    }

    let products = document.querySelectorAll("#product-listing li");
    products.forEach(function (productItem) {
        productItem.addEventListener('mouseover', function () {
            productItem.classList.add('hover');
        });
        productItem.addEventListener('mouseout', function () {
            productItem.classList.remove('hover');
        });
    });
}

function addFiltersEventListeners() {
    let sortBySelect = document.getElementById("resultSortSelector") as HTMLSelectElement;
    if (sortBySelect != null) {
        sortBySelect.addEventListener("change", handleSortSelectorChange);
        sortBySelect.value = _ShopByProduct_CurrentOrder;
    }


    var clearBtn = document.getElementsByClassName("filter-clear");

    for (var i = 0; i < clearBtn.length; i++) {
        clearBtn[i].addEventListener('click', handleClearFilter);
    }

    var filterOpt = document.getElementsByClassName("filter-option");

    for (var i = 0; i < filterOpt.length; i++) {
        filterOpt[i].addEventListener('click', applyFilters);
    }

    var filterTag = document.getElementsByClassName("filter-tag");

    for (var i = 0; i < filterTag.length; i++) {
        filterTag[i].addEventListener('click', handleRemoveFilter);
    }

    var showAllRad = document.getElementById("showAllRad")!;
    if (showAllRad) {
        showAllRad.addEventListener("change", handleShowAll);
    }

    var inStockOnlyRad = document.getElementById("inStockOnlyRad")!;
    if (inStockOnlyRad)
        inStockOnlyRad.addEventListener("change", handleInStockOnly);
    //extra check for mobile filters as they keep clearing
    if (_inStock) {
        if (showAllRad)
            (<HTMLInputElement>showAllRad).checked = false;
        if (inStockOnlyRad)
            (<HTMLInputElement>inStockOnlyRad).checked = true;
    }
    else {
        if (showAllRad)
            (<HTMLInputElement>showAllRad).checked = true;
        if (inStockOnlyRad)
            (<HTMLInputElement>inStockOnlyRad).checked = false;
    }

    var showAllBrandsButton = document.getElementById("showAllFilters-brands")!;
    if (showAllBrandsButton)
        showAllBrandsButton.addEventListener("click", (e) => handleFilterToggle(e, showAllBrandsButton, "brands"));

    var filterBrandsInput = document.getElementById("filterBrands")!;
    if (filterBrandsInput)
        filterBrandsInput.addEventListener("input", () => handleBrandsFilter(showAllBrandsButton));
    var filterBrandSeriesInput = document.getElementById("filterBrandSeries")!;
    if (filterBrandSeriesInput)
        filterBrandSeriesInput.addEventListener("input", () => handleBrandSeriesFilter());
    var filterCategoriesInput = document.getElementById("filterCategories")!;
    if (filterCategoriesInput)
        filterCategoriesInput.addEventListener("input", () => handleCategoriesFilter());
    var filterTypesInput = document.getElementById("filterTypes")!;
    if (filterTypesInput)
        filterTypesInput.addEventListener("input", () => handleTypesFilter());
    var filterSubTypesInput = document.getElementById("filterSubTypes")!;
    if (filterSubTypesInput)
        filterSubTypesInput.addEventListener("input", () => handleSubTypesFilter());
}

function addPagingEventListeners() {
    var pageButtons = document.querySelectorAll('.paging-section .page-num');
    if (pageButtons.length) {
        for (var i = 0; i < pageButtons.length; i++) {
            pageButtons[i].addEventListener('click', handlePageClick);
        }
    }
    var pagePrevious = document.querySelector('.paging-section .page-prev');
    if (pagePrevious) {
        pagePrevious.addEventListener('click', handlePreviousPage);
    }
    var pageNext = document.querySelector('.paging-section .page-next');
    if (pageNext) {
        pageNext.addEventListener('click', handleNextPage);
    }
}

function viewAsGrid(isGridView: boolean) {
    let mask = document.querySelector('.product-listing-container .mask');
    if (mask) {
        mask.classList.add("hide-contents");
    }

    let productList = document.getElementById('product-listing');
    let viewControlList = document.getElementById('productlist-view-list');
    let viewControlGrid = document.getElementById('productlist-view-grid');

    if (isGridView && productList) {
        if (viewControlList) viewControlList.classList.remove("active");
        if (viewControlGrid) viewControlGrid.classList.add("active");
        productList.classList.add("grid");
        productList.classList.remove("list-view");
    }
    else if (productList) {
        if (viewControlList) viewControlList.classList.add("active");
        if (viewControlGrid) viewControlGrid.classList.remove("active");
        productList.classList.remove("grid");
        productList.classList.add("list-view");
    }

    //add timeout to account for css transition
    setTimeout(function () {
        if (mask) {
            mask.classList.remove("hide-contents");
        }
    }, 200);

    let filtersMask = document.querySelector('.filter-row-controls .list-view');
    if (filtersMask) {
        filtersMask.classList.remove("hidden");
    }

    var listLayout = Utils.getCookie(ListLayoutCookieName);

    if (_hasFilter && (isGridView && listLayout != 'grid') || (!isGridView && listLayout != 'list'))
        setSearchFilters(_filtersModel, true);

    Utils.setCookie(ListLayoutCookieName, isGridView ? "grid" : "list", 730);
}

function closeModal() {
    var showAllBrandsButton = document.getElementById("showAllFilters-brands")!;
    if (showAllBrandsButton) {
        minimiseFilters(showAllBrandsButton, "brands");
    }
    openCloseFilterModal(false);
}

function handleToggleClick(evt: any) {
    let elem = evt.target as HTMLElement;
    if ((evt.target as any).tagName != "BUTTON") {
        elem = (evt.target as any).parentNode;
    }
    var msg = elem.firstChild;
    var closeddmsg = elem.getAttribute('data-closedmsg');
    var toggledmsg = elem.getAttribute('data-toggledmsg');
    var item = elem.parentElement?.parentElement?.querySelector('.toggle-content');

    if (item && msg && item.classList.contains('show')) {
        item.classList.remove('show');
        if (closeddmsg) {
            if (msg.nextSibling) {
                (msg.nextSibling as HTMLElement).innerHTML = closeddmsg;
            }
            else {
                (msg as HTMLElement).innerHTML = closeddmsg;
            }
        }
        elem.setAttribute('aria-expanded', 'false')
    }
    else if (item && msg) {
        item.classList.add('show');
        if (toggledmsg) {
            if (msg.nextSibling) {
                (msg.nextSibling as HTMLElement).innerHTML = toggledmsg;
            }
            else {
                (msg as HTMLElement).innerHTML = toggledmsg;
            }
        }
        elem.setAttribute('aria-expanded', 'true');
    }
}

function handleRemoveFilter(event: any) {
    const target = event.target as HTMLElement;
    var filter = target.closest("button")!;
    var type = filter.getAttribute("data-type")!;
    var id = filter.getAttribute("data-id")!;
    if (type == "brand") {
        var brand = (<HTMLInputElement>document.getElementById(`brands-${id}`));
        brand.checked = false;

        var brandSeries = document.querySelectorAll(`[id*=brandseries][data-parent-id='${id}']`);

        if (brandSeries) {
            brandSeries.forEach(function (e: any) {
                e.checked = false;
            });
        }
    }

    if (type == "category") {
        var category = (<HTMLInputElement>document.getElementById(`categories-${id}`));

        category.checked = false;
    }

    if (type == "productType") {
        var productType = (<HTMLInputElement>document.getElementById(`types-${id}`));

        productType.checked = false;
    }

    if (type == "productSubType") {
        var productSubType = (<HTMLInputElement>document.getElementById(`subtypes-${id}`));

        productSubType.checked = false;
    }

    if (type == "brandSerie") {
        var brandSerie = (<HTMLInputElement>document.getElementById(`brandseries-${id}`));

        brandSerie.checked = false;
    }

    if (type == "inStock") {
        var inStock = (<HTMLInputElement>document.getElementById("inStockOnlyRad"));

        inStock.checked =
            _inStock = false;

    }

    applyFilters();
}

function handleBrandsFilter(showAllButton?: HTMLElement) {
    showHideFilterOptions('filterBrands', '*[id^="brands-"]');
}

function showHideFilterOptions(filterID: string, querySelectorString: string) {
    var filter = (<HTMLInputElement>document.getElementById(filterID))!.value!.toLowerCase();
    var options = document.querySelectorAll(querySelectorString);

    options.forEach(function (element, index) {
        let name = element.getAttribute("name")!.toLowerCase();
        let brandChk = document.getElementById(element.id)!;
        let parent = brandChk.parentElement!;
        parent.classList.remove("hide", "show");
        if (filter === "" || filter === undefined || filter === null) {
            parent.classList.add("show");
        } else if (name.includes(filter)) {
            parent.classList.add("show");
        } else {
            parent.classList.add("hide");
        }
    });
}

function handleBrandSeriesFilter() {
    showHideFilterOptions('filterBrandSeries', '*[id^="brandseries-"]');
}

function handleCategoriesFilter() {
    showHideFilterOptions('filterCategories', '*[id^="categories-"]');
}

function handleTypesFilter() {
    showHideFilterOptions('filterTypes', '*[id^="types-"]');
}

function handleSubTypesFilter() {
    showHideFilterOptions('filterSubTypes', '*[id^="subtypes-"]');
}

function handleFilterToggle(event: MouseEvent, button: HTMLElement, filterType: string) {
    event.stopImmediatePropagation();
    var brands = document.querySelectorAll(`*[id^="${filterType}-"]`);

    brands.forEach(function (item, index) {
        let brandChk = document.getElementById(item.id)!;
        let parent = brandChk.parentElement!;
        parent.classList.remove("hide", "show");

        if (button.innerHTML === "See all") {
            parent.classList.add("show");
        } else if (button.innerHTML === "See less") {
            if (parent.classList.contains("fixed")) {
                parent.classList.add("show");
            } else {
                parent.classList.add("hide");
            }

        }
    })
    button.innerHTML = button.innerHTML === "See all" ? "See less" : "See all";
}

function minimiseFilters(button: HTMLElement, filterType: string) {
    var brands = document.querySelectorAll(`*[id^="${filterType}-"]`);
    brands.forEach(function (item, index) {
        let brandChk = document.getElementById(item.id)!;
        let parent = brandChk.parentElement!;
        parent.classList.remove("hide", "show");

        if (parent.classList.contains("fixed")) {
            parent.classList.add("show");
        } else {
            parent.classList.add("hide");
        }
    })
    button.innerHTML = "See all";
}

function handleInStockOnly() {
    //showHideSpinner(true);
    var showAllRad = <HTMLInputElement>document.getElementById("showAllRad")!;

    showAllRad.checked = false;
    _inStock = true;
    _refreshProducts = true;
    applyFilters();
}

function handleShowAll() {
    //showHideSpinner(true);
    var inStockOnlyRad = <HTMLInputElement>document.getElementById("inStockOnlyRad")!;

    inStockOnlyRad.checked = false;
    _inStock = false;
    applyFilters();
}

function handleClearFilter() {
    var inStock = (<HTMLInputElement>document.getElementById("inStockOnlyRad"));

    inStock.checked =
        _inStock = false;

    var elements = document.querySelectorAll(".filter-option");

    if (elements) {
        elements.forEach(function (item: any) {
            var chk = (item as HTMLInputElement);
            if (chk) {
                chk.checked = false;
            }
        })
    }

    _filtersModel.PriceRange.SelectedMin = null;
    _filtersModel.PriceRange.SelectedMax = null;
    //if (mediaQuery.matches) {
    //    let contentAreaMobile = document.getElementById('filter-content-area-mobile');
    //    let rangeSlider = contentAreaMobile?.querySelectorAll('.rs-container');
    //    if (rangeSlider && rangeSlider.length > 0) {
    //        rangeSlider[0].remove();
    //    }
    //    _resetSlider = true;
    //    initRangeSlider();
    //}
    _resetSlider = true;
    applyFilters();
}

function getStateFromUrl() {
    return history.state;
}

function getStateObjFromUrl(): any {
    var result: any = {};
    var fragments = location.href.split("?")[1];
    if (fragments != null) {
        var fragmentKvps = fragments.split("&");
        var queryKvp = fragmentKvps.forEach(function (element, index) {
            var key = element.split("=")[0];
            var value = element.split("=")[1];

            if (key != null) {
                result[key] = value;
            }
        });
    }

    return result;
}

function getSelectedCategoryIds(categoryVM: any) {
    if (categoryVM == null || categoryVM.Options == null) {
        return [];
    }

    var selectedOptions = categoryVM.Options.filter(function (s: any) { return s.IsSelected === true; })
    var selectedIds = selectedOptions.map(function (s: any) { return s.ID; });

    return selectedIds;
}

function searchFromState(state: any) {
    var urlState = getStateObjFromUrl();
    if (!state) {
        //showHideSpinner(false);
        return;
    }

    if (state.searchText == null || state.searchText === "") {
        state.searchText = urlState.q;
    }

    if (state.page == null || state.page === "") {
        state.page = urlState.page;
        if (state.page && !_pageHasChanged)
            _pageNum = state.page;
        else if (!state.page && !_pageHasChanged)
            _pageNum = 1;
    }

    if (state.sortBy == null || state.sortBy === "") {
        state.sortBy = urlState.sort;
    }

    _numberOfItems = _numberOfItems >= 6 ? _numberOfItems : 6
    state.size = _numberOfItems;
    state.sort = _ShopByProduct_CurrentOrder;

    var parameters = [];
    parameters.push(getQS("q", state.searchText));
    if (_pageNum > 1)
        parameters.push(getQS("page", _pageNum));

    if (_ShopByProduct_CurrentOrder != _Default_SortOrder)
        parameters.push(getQS("sort", _ShopByProduct_CurrentOrder));
    //parameters.push(getQS("auto", state.AutoFilter));
    parameters.push(getQS("stockonly", _inStock));

    if (state.PriceRange?.SelectedMin)
        parameters.push(getQS("min", state.PriceRange == null ? "" : state.PriceRange.SelectedMin || Math.floor(state.PriceRange.MinProductPrice)));

    if (state.PriceRange?.SelectedMax)
        parameters.push(getQS("max", state.PriceRange == null ? "" : state.PriceRange.SelectedMax || Math.ceil(state.PriceRange.MaxProductPrice)));

    //Categories
    var selectedBrands = getSelectedCategoryIds(state.Brands);

    var selectedBrandSeries = getSelectedCategoryIds(state.BrandSeries, selectedBrands);
    var selectedCategories = getSelectedCategoryIds(state.Categories);
    var selectedProductTypes = getSelectedCategoryIds(state.ProductTypes);
    var selectedProductSubTypes = getSelectedCategoryIds(state.ProductSubTypes, state.ProductTypes);

    parameters.push(getQS("b", selectedBrands.join(",")));
    parameters.push(getQS("bs", selectedBrandSeries.join(",")));
    parameters.push(getQS("cat", selectedCategories.join(",")));
    parameters.push(getQS("pt", selectedProductTypes.join(",")));
    parameters.push(getQS("pst", selectedProductSubTypes.join(",")));

    var currentLayout = getCurrentLayout();
    var layoutFromCookies = Utils.getCookie(ListLayoutCookieName);

    if (currentLayout != layoutFromCookies)
        parameters.push(getQS("layout", getCurrentLayout()));

    //Custom classifications                
    if (state.CustomClassifications != null) {
        state.CustomClassifications.forEach(function (index: any, value: any) {
            var cc = value;
            var classificationId = cc.ID;
            var selectedIds = getSelectedCategoryIds(cc);

            parameters.push(getQS("cc" + classificationId, selectedIds.join(",")));
        });
    }

    var newState = state || {};
    //Preserving OriginalState
    newState.OriginalState = JSON.parse(JSON.stringify((history.state || state.OriginalState || {})));

    var search = "";
    var params = parameters.filter(p => p !== null);

    if (params.length > 0)
        search = "?" + params.join("&");

    //Setting state in history as well
    //Replacing state if url matches, pushing new state otherwise

    if (newState.Brands)
        newState.Brands.Options.map(function (s: any) {
            s.IsSelected = selectedBrands.includes(s.ID);
        });

    if (newState.BrandSeries)
        newState.BrandSeries.Options.map(function (s: any) {
            s.IsSelected = selectedBrandSeries.includes(s.ID);
        });

    if (newState.Categories)
        newState.Categories.Options.map(function (s: any) {
            s.IsSelected = selectedCategories.includes(s.ID);
        });

    if (newState.ProductTypes)
        newState.ProductTypes.Options.map(function (s: any) {
            s.IsSelected = selectedProductTypes.includes(s.ID);
        });

    if (newState.ProductSubTypes)
        newState.ProductSubTypes.Options.map(function (s: any) {
            s.IsSelected = selectedProductSubTypes.includes(s.ID);
        });

    var inStockOnlyRad = <HTMLInputElement>document.getElementById("inStockOnlyRad")!;

    newState.IsInStockOnly = inStockOnlyRad.checked;
    newState.IsInStockShowAll = !inStockOnlyRad.checked;

    history.replaceState(newState, "replacing existing state", removeParam("categoryId", window.location.href));

    return search;

    function getQS(key: any, value: any) {
        if (value === null
            || value === undefined
            || value === "") {
            return null;
        }

        return key + "=" + value;
    }

    function getSelectedCategoryIds(categoryVM: any, parentIds: any = null) {
        if (categoryVM == null || categoryVM.Options == null) {
            return [];
        }

        var categoryName = categoryVM.CategoryName.replace(/\s/g, '').toLowerCase();
        var selectedOptions = categoryVM.Options.filter(function (s: any) {
            var element = <HTMLInputElement>document.querySelector(`[id=${categoryName}-${s.ID}].filter-option`);
            var filterParent = true;

            if (parentIds != null && element != null) {
                var elementParentId = element.getAttribute("data-parent-id");

                if (elementParentId)
                    filterParent = parentIds.includes(+elementParentId)
            }

            return element != null && element.checked && filterParent;
        });

        var selectedIds = selectedOptions.map(function (s: any) { return s.ID; });

        return selectedIds;
    }

    function getCurrentLayout() {
        var layoutSelected = document.querySelector("[id*=productlist-view].active");

        if (layoutSelected)
            return layoutSelected.id.slice(-4);
    }
}

function setSearchFilters(filters: any, skipReload: boolean = false) {
    var search = searchFromState(filters);

    //Assigning same value to location.href will set history.state to null
    //However, no events will be triggered
    var splitUrl = window.location.href.split('?');
    var url = splitUrl[0];
    if (splitUrl.length > 1) {
        url = window.location.href;

        urlParams.forEach(function (filter) {
            if (url.includes(filter))
                url = removeParam(filter, url);
        });

        if (search && url.includes("?"))
            search = search.replace("?", "&");
    }

    if (location.search !== search) {
        history.replaceState(history.state, '', url + search)

        _refreshProducts = !skipReload;
        if (_refreshProducts
            && window.location.href.indexOf("more-panel") == -1) {
            var filtersModel = getSearchFilters();
            refreshProductList(filtersModel);
        }
    }
    //else showHideSpinner(false);
}

function getSearchFilters() {
    var result = getStateFromUrl();
    return result;
}

function applyFilters() {
    //showHideSpinner(true); 
    _scrollUp = true;
    _refreshProducts = true;
    _pageNum = 1; //reset page when any filters are applied
    setSearchFilters(_filtersModel);

    let countFilters = document.getElementById('filterCount');
    if (countFilters) {
        let stringCount = countFilters.innerHTML.replace('(', '').replace(')', '');
        //_filtersModel.PriceRange.SelectedMin = _filtersModel.PriceRange.MinProductPrice;
        //_filtersModel.PriceRange.SelectedMax = _filtersModel.PriceRange.MaxProductPrice;
        if (_filtersModel.PriceRange.SelectedMin != _filtersModel.PriceRange.MinProductPrice || _filtersModel.PriceRange.SelectedMax != _filtersModel.PriceRange.MaxProductPrice) {
            let num = parseInt(stringCount) ? NaN : 0;
            countFilters.innerHTML = '(' + (num + 1) + ')';
        }
        if (stringCount == '0') {
            countFilters.innerHTML = '';
        }
    }
}

function handleSortSelectorChange(event: any) {
    var selectElement = event.target;
    var value = selectElement.value;
    _refreshProducts = true;
    _ShopByProduct_CurrentOrder = value;

    if (_hasFilter)
        setSearchFilters(_filtersModel);
    else
        refreshProductList(null)
}

function handleLoadMoreClick() {
    setLoadingButton(true);
    var filtersModel = getSearchFilters();
    _numberOfItems = filtersModel ? filtersModel.size + _pageSize : _numberOfItems + _pageSize;
    _scrollUp = false;
    _refreshProducts = true;
    if (_hasFilter)
        setSearchFilters(_filtersModel);
    else
        refreshProductList(null);
}

function handlePageClick(event: any) {
    event.preventDefault();
    let goToPageNum = event.target.attributes['data-page-num'].value;
    var filtersModel = getSearchFilters();
    _pageNum = parseInt(goToPageNum);
    changePage();
}

function changePage() {
    _scrollUp = true;
    _refreshProducts = true;
    _pageHasChanged = true;
    if (_hasFilter)
        setSearchFilters(_filtersModel);
    else
        refreshProductList(null);
}


function handlePreviousPage(event: any) {
    event.preventDefault();
    _pageNum = _pageNum > 1 ? parseInt(_pageNum.toString()) - 1 : 1;
    changePage();
}

function handleNextPage(event: any) {
    event.preventDefault();

    _pageNum = _pageNum < _maxPage ? parseInt(_pageNum.toString()) + 1 : _maxPage;
    changePage();
}

function resetPaging() {
    let maxPageContainer = document.getElementById('maxPages');
    if (maxPageContainer) {
        _maxPage = parseInt(maxPageContainer.innerHTML);
    }
    _pageHasChanged = false;
    let numPrevious = parseInt(_pageNum.toString()) > Math.ceil(maxDisplayPageNum / 2) ?
        parseInt(_pageNum.toString()) - Math.floor(maxDisplayPageNum / 2) :
        1;
    let numNext = parseInt(_pageNum.toString()) > Math.ceil(maxDisplayPageNum / 2) ?
        parseInt(_pageNum.toString()) + (Math.ceil(maxDisplayPageNum / 2) - 1) :
        maxDisplayPageNum;
    //check for end of page list
    if (numNext > _maxPage) {
        numNext = _maxPage;
        numPrevious = _maxPage - maxDisplayPageNum;
    }
    console.log('resetPaging() ' + numPrevious + '**' + numNext + '**' + _maxPage);
    let allPages = Array.from(document.querySelectorAll('.paging-section .pages-wrapper .page-num'));
    if (allPages.length) {
        allPages.map(page => {
            let currpage = page.attributes.getNamedItem('data-page-num');
            if (page != null && currpage != null && currpage.value != null) {
                let currPageValue = parseInt(currpage.value);
                if ((currPageValue as number) == _pageNum) {
                    page.classList.add('current');
                }
                else page.classList.remove('current');
                if (currPageValue == _pageNum ||
                    (currPageValue >= numPrevious && currPageValue < _pageNum) ||
                    (currPageValue > _pageNum && currPageValue <= numNext) ||
                    (currPageValue == 1) ||
                    (currPageValue == _maxPage)) {
                    page.classList.remove('hidden');
                }
                else {
                    page.classList.add('hidden');
                }
            }
        })
    }
    let pagePrev = document.querySelector('.paging-section .page-prev');
    let pageNext = document.querySelector('.paging-section .page-next');
    let pageMorePrev = document.querySelector('.paging-section .more-previous');
    let pageMoreNext = document.querySelector('.paging-section .more-next');

    if (_pageNum > 1 && pagePrev) pagePrev.classList.remove('hidden');
    else if (pagePrev) pagePrev.classList.add('hidden');
    if (_pageNum < _maxPage && pageNext) pageNext.classList.remove('hidden');
    else if (pageNext) pageNext.classList.add('hidden');
    if (numPrevious > 2 && pageMorePrev) pageMorePrev.classList.remove('hidden');
    else if (pageMorePrev) pageMorePrev.classList.add('hidden');
    if (numNext > (_maxPage - 1) && pageMoreNext) pageMoreNext.classList.add('hidden');
    else if (pageMoreNext) pageMoreNext.classList.remove('hidden');
}

function setLoadingButton(isLoading: boolean) {
    var loadMoreBtn = document.getElementById("loadMore");
    if (loadMoreBtn) {
        if (isLoading) loadMoreBtn.classList.add('btn-loading');
        else loadMoreBtn.classList.remove('btn-loading');
    }
}


function refreshProductList(filtersModel: any) {
    //showHideSpinner(true); 
    if (!_refreshProducts) {
        setLoadingButton(false);
        showHideSpinner(false);
        return;
    }


    var myJSONString = JSON.stringify(filtersModel);
    var myEscapedJSONString = myJSONString.replace(/\\n/g, "\\n")
        .replace(/\\'/g, "\\'")
        .replace(/\\"/g, '\\"')
        .replace(/\\&/g, "\\&")
        .replace(/\\r/g, "\\r")
        .replace(/\\t/g, "\\t")
        .replace(/\\b/g, "\\b")
        .replace(/\\f/g, "\\f");

    var token = document.getElementById("productListContainer")!.getAttribute("ncg-request-verification-token")!;

    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set("requestverificationtoken", token);
    requestHeaders.set('Content-Type', 'application/json');

    var body = {
        operation: "rebrandFilterProducts",
        sort: filtersModel ? filtersModel.sort : _ShopByProduct_CurrentOrder,
        orderBy: _ShopByProduct_CurrentOrder,
        filters: myEscapedJSONString,
        pageName: _pageName,
        pageID: _pageID,
        pageRegionID: _pageRegionID,
        categoryID: _categoryID,
        page: _pageNum,
        pageSize: _pageSize
    };

    var url = _hasFilter ? _getProductsUrl : _ShopByProduct_RefreshProductListUrl;

    fetch(url, {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify(body)
    }).then(response => response.text())
        .then(function (data: any) {
            //retain current list view
            var productListingElem = document.getElementById('product-listing');
            var currentView = 'grid';
            if (productListingElem && !productListingElem.classList.contains('grid')) currentView = 'list';
            if (currentView == 'grid') {
                //as this is not the default
                data = (data as string).replace('<button id="productlist-view-list" class="active">', '<button id="productlist-view-list">');
                data = (data as string).replace('<button id="productlist-view-grid">', '<button id="productlist-view-grid" class="active">');
                data = (data as string).replace('<ul class="list-view cols-2-mob cols-4" role="list" id="product-listing">', '<ul class="grid cols-2-mob cols-4" role="list" id="product-listing">');
                data = (data as string).replace('<ul class="list-view cols-2-mob cols-4 no-margin" role="list" id="product-listing">', '<ul class="grid cols-2-mob cols-4 no-margin" role="list" id="product-listing">');
                data = (data as string).replace('<div class="mask hide-contents"></div>', '<div class="mask"></div>');
            }
            else {
                data = (data as string).replace('<button id="productlist-view-list">', '<button id="productlist-view-list" class="active">');
                data = (data as string).replace('<button id="productlist-view-grid" class="active">', '<button id="productlist-view-grid">');
                data = (data as string).replace('<ul class="grid cols-2-mob cols-4" role="list" id="product-listing">', '<ul class="list-view cols-2-mob cols-4" role="list" id="product-listing">');
                data = (data as string).replace('<ul class="grid cols-2-mob cols-4 no-margin" role="list" id="product-listing">', '<ul class="list-view cols-2-mob cols-4 no-margin" role="list" id="product-listing">');
                data = (data as string).replace('<div class="mask hide-contents"></div>', '<div class="mask"></div>');
            }
            data = (data as string).replace('<div class="list-view hidden">', '<div class="list-view">');


            if (_hasFilter) {
                if (_isFiltering) {
                    data = (data as string).replace('class="filter-menu form full-width loading"', 'class="filter-menu form full-width"');
                }
                else if (!_isFiltering && mediaQuery.matches) {
                    data = (data as string).replace('class="filter-menu form full-width loading"', 'class="filter-menu form full-width modal slide-in-modal bg-white a11y-modal hidden-modal"');
                }
                //desktop - load the HTML as it is


                if (!_resetSlider) {
                    let parser = new DOMParser();
                    const doc = parser.parseFromString(data, 'text/html');
                    var rerenderContainer = doc.getElementById("filterRerenderableContainer");
                    var productListContainer = doc.getElementById("productListContainer")!;

                    document.getElementById("filterRerenderableContainer")!.innerHTML = rerenderContainer!.innerHTML;
                    document.getElementById("productListContainer")!.innerHTML = productListContainer!.innerHTML;

                    let viewControlList = document.getElementById('productlist-view-list');
                    let viewControlGrid = document.getElementById('productlist-view-grid');

                    if (currentView == 'grid' && viewControlList && viewControlGrid) {
                        viewControlList.classList.remove('active');
                        viewControlGrid.classList.add('active');
                    }
                    else if (viewControlList && viewControlGrid) {
                        viewControlGrid.classList.remove('active');
                        viewControlList.classList.add('active');
                    }
                } else {
                    document.getElementById("productListFilter")!.outerHTML = data;
                }

                checkForMobile(false);
            }
            else {
                let parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');

                document.getElementById("products-panel")!.innerHTML = doc.getElementById("products-panel")!.innerHTML;
            }
            pushEnhancedEcommerce();
            addEventListeners();
            initRangeSlider();
            //if ((window as any).ARIAmodal)
            //    (window as any).ARIAmodal.setupTrigger();          
            resetPaging();
            if (_scrollUp) {
                let listContainer = document.getElementById("productListContainer");
                if (listContainer) {
                    listContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }

            let sortBySelect = document.getElementById("resultSortSelector") as HTMLSelectElement;

            if (sortBySelect)
                sortBySelect.value = filtersModel ? filtersModel.sort : _ShopByProduct_CurrentOrder;

            setLoadingButton(false);
            showHideSpinner(false);

            //desktop filter area gets redrawn
            /*ON HOLD - come back later for this
             if (mediaQuery.matches) {
                let contentAreaMobile = document.getElementById('filter-content-area-mobile');
                let contentAreaDesktop = document.getElementById('filter-content-area-desktop');
                let rangeSlider = contentAreaMobile?.querySelectorAll('.rs-container');
                if (contentAreaMobile && contentAreaDesktop) {
                    if (rangeSlider && rangeSlider.length > 0) {
                        rangeSlider[0].remove();
                    }
                    contentAreaMobile.innerHTML = (contentAreaDesktop.cloneNode(true) as HTMLElement).innerHTML;
                    contentAreaDesktop.innerHTML = '';
                    initRangeSlider();
                }
                addEventListeners();
            }*/
        });
}

function showHideSpinner(show: boolean) {
    let spinner = document.querySelector('.page-loading-spinner');
    if (spinner) {
        if (show) {
            //only show spinner if filter modal is active
            var activeModal = document.getElementById("productListingFilter");
            if (activeModal && !activeModal.classList.contains('hidden-modal')) {
                (spinner as HTMLElement).classList.remove('hidden');
            }
        }
        else {
            (spinner as HTMLElement).classList.add('hidden');
        }
    }
}

function openCloseFilterModal(isOpening: boolean) {
    var activeModal = document.getElementById("productListingFilter");
    if (isOpening && activeModal) {
        let htmlMain = document.getElementsByTagName('html');
        if (htmlMain[0]) htmlMain[0].classList.add('filter-modal-open');
        activeModal.classList.remove('hidden-modal');
        _isFiltering = true;
    }
    else if (activeModal) {
        let htmlMain = document.getElementsByTagName('html');
        if (htmlMain[0]) htmlMain[0].classList.remove('filter-modal-open');
        activeModal.classList.add('hidden-modal');
        _isFiltering = false;
    }
}

function checkForMobileResize() {
    if (!mediaQuery.matches && pageWidth != window.innerWidth) {
        pageWidth = window.innerWidth;
        checkForMobile(true);
    }

    let testWindowWidth = window.innerWidth;

    let test = document.getElementById('test-grids');


    if (mediaQuery.matches && windowWidth != testWindowWidth) {
        windowWidth = testWindowWidth;
        //change only if window width has really changed, this is triggered on page scroll for some reason
        var listLayout = Utils.getCookie(ListLayoutCookieName);
        var isGridView = listLayout == "grid";

        viewAsGrid(isGridView);
    }
}

function spinnerMessage(message: string) {
    let msg = document.getElementById('spinner-message');
    if (msg) {
        msg.innerText = msg.innerText + '** ' + message;
    }
}

function checkForMobile(hideModal: boolean) {
    let filterBlock = document.getElementById('productListingFilter');
    if (mediaQuery.matches && filterBlock) {
        //showHideSpinner(true);
        filterBlock.classList.add('modal');
        filterBlock.classList.add('slide-in-modal');
        filterBlock.classList.add('bg-white');
        filterBlock.classList.add('a11y-modal');
        if (hideModal) filterBlock.classList.add('hidden-modal');
        if (_isPageLoad) {
            setTimeout(() => {
                let filterBlock = document.getElementById('productListingFilter');
                if (filterBlock) filterBlock.classList.remove('loading');
            }, 750);
        }
        //showHideSpinner(false);
    }
    else if (filterBlock) {
        filterBlock.classList.remove('modal');
        filterBlock.classList.remove('slide-in-modal');
        filterBlock.classList.remove('bg-white');
        filterBlock.classList.remove('a11y-modal');
        filterBlock.classList.remove('hidden-modal');
    }
}

function removeParam(key: any, sourceURL: any) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

function setListLayoutFromURL() {
    if (window.location.href.indexOf("grid") > -1) {
        Utils.setCookie(ListLayoutCookieName, "grid", 730);
    }
    if (window.location.href.indexOf("list") > -1) {
        Utils.setCookie(ListLayoutCookieName, "list", 730);
    }
}

/*window.onhashchange = function () {
    if (window.location.href.indexOf("more-panel") == -1 && window.location.href.indexOf("#") > -1) {
        var filtersModel = getSearchFilters();
        refreshProductList(filtersModel);
    }
}*/

function setCurrentPage(state: any) {
    var urlState = getStateObjFromUrl();
    if (!state) {
        return;
    }

    if (state.searchText == null || state.searchText === "") {
        state.searchText = urlState.q;
    }

    if (state.page == null || state.page === "") {
        state.page = urlState.page;
        if (state.page && !_pageHasChanged)
            _pageNum = state.page;
        else if (!state.page && !_pageHasChanged)
            _pageNum = 1;
    }
}

window.onload = function () {
    setListLayoutFromURL();

    _isPageLoad = true;

    if (_hasFilter)
        setCurrentPage(_filtersModel);

    addEventListeners();
    checkForMobile(true);
    pushEnhancedEcommerce();
    //showHideSpinner(false);
    windowWidth = window.innerWidth;
    var listLayout = Utils.getCookie(ListLayoutCookieName);
    console.log(listLayout);
    console.log(mediaQuery.matches);
    var isGridView = listLayout == "grid" || (listLayout === undefined && !mediaQuery.matches);

    viewAsGrid(isGridView);

    if (_hasFilter)
        resetPaging();
}

window.onresize = debouncedResizeFunction;
window.onorientationchange = debouncedResizeFunction;